import React from "react";
import { TeamHero, TeamSection } from "../../components/sections/team";

export default function Team(props) {
	return (
		<>
			<TeamHero />

			<TeamSection />
		</>
	);
}
